import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import s from './TickerList.module.scss';

interface TickerListProps {
  items?: Array<React.ReactNode>;
  className?: string;
}

const TickerList = ({ items, className }: TickerListProps) => {
  if (isEmpty(items)) {
    return null;
  }

  return (
    <div className={cn(s.TickerList, s.TickerHover, className)}>
      <ul className={cn(s.TickerList__cards)}>
        {items?.map((item, i) => (
          <li key={`item-${i}`} className={cn(s.TickerList__item)}>
            {item}
          </li>
        ))}
      </ul>
      <ul className={cn(s.TickerList__cards)} aria-hidden="true">
        {items?.map((item, i) => (
          <li key={`item-${i}`} className={cn(s.TickerList__item)}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TickerList;
